/**
 * Representation of the Artist Entity
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

export { ImageList };

import { linkBaseURL } from './../config.js'

/**	A List of Images */
class ImageList {

	constructor(data) {
		this.images = [];
		this.data = data;

		// Parse List of Images
		try {
			if (typeof data === "string") {
				data = JSON.parse(data);
			}
			if (typeof data === "object" && data != null && data.constructor.name == "Array") {
				for (let i = 0; i < data.length; i++) {
					if (typeof data [i].category !== 'undefined' && data [i].category !== 'image') {
						if (data [i].category == 'youtube') {
							this.images.push(new MediaYouTube(data [i]));
						} else if (data [i].category == 'audio') {
							this.images.push(new MediaAudio(data [i]));
						} else if (data [i].category == 'video') {
							this.images.push(new MediaVideo(data [i]));
						}
					} else {
						// default is classic image
						if (typeof data [i].original !== 'undefined' && typeof data [i].large !== 'undefined' && typeof data [i].small !== 'undefined') {
							this.images.push(new Image(data [i]));
						} 
					}
				}
			}
		} catch (e) {
			console.log('Failing at parsing image descriptor');
			console.log(data);
		}
	}

	
	// Basic Getters
	hasImages() {
		return this.images.length > 0;
	}
	
	getImageCount() {
		return this.images.length;
	}
	
	getImageAt(at) {
		return this.images [at];
	}
	
	getImages() {
		return this.images;
	}

	// Utility

	isImage(index) {
		if (typeof index === "undefined" || index < 0 || index >= this.images.length) {
			index = 0;
		}

		if (this.hasImages() == false) {
			return true;
		}
		let image = this.images [index];
		return image.isImage()

	}

	getMultiMediaHTML(index, mode) {
		if (typeof index === "undefined" || index < 0 || index >= this.images.length) {
			index = 0;
		}
		let media = this.images [index];
		return media.getMultiMediaHTML(mode);
	}
	
	getImageURL(size, index) {
		if (typeof index === "undefined" || index < 0 || index >= this.images.length) {
			index = 0;
		}

		if (this.hasImages() == false) {
			return "missing.png";
		}
		if (typeof size === "undefined") {
			size = "original";
		}
		let image = this.images [index];
		
		if (size == "original") {
			return image.getOriginal().getLink();
		} else if (size == "large") {
			return image.getLarge().getLink();
		} else if (size == "small") {
			return image.getSmall().getLink();
		}
		
		return "";
	}
	
	/* Get the Aspect Ratio, defined as height / width */
	getAspectRatio(index) {
		if (typeof index === "undefined" || index >= this.images.length) {
			index = 0;
		}
		if (this.hasImages() == false) {
			return 1.0;
		}
		let image = this.images [index];
		return image.getAspectRatio();		
	}

}

/**	An Image with 3 sizes: original, large and small */
class Image {

	constructor(data) {
		this.uid = data.uid;
		this.original = new ImageVariant(data.original);
		if (typeof data.large !== 'undefined') {
			this.large = new ImageVariant(data.large);
		} else {
			this.original = new ImageVariant(data.original);
		}
		if (typeof data.small !== 'undefined') {
			this.small = new ImageVariant(data.small);
		} else {
			this.small = new ImageVariant(data.original);
		}
	}
	
	// Basic Getter
	
	isImage() {
		return true;
	}

	isMultiMedia() {
		return false;
	}


	getUID() {
		return this.uid;
	}
	
	getOriginal() {
		return this.original;
	}
	
	getLarge() {
		return this.large;
	}
	
	getSmall() {
		return this.small;
	}

	getImageURL(size) {
		if (typeof size === "undefined") {
			size = "original";
		}
		
		if (size == "original") {
			return this.original.getLink();
		} else if (size == "large") {
			return this.large.getLink();
		} else if (size == "small") {
			return this.small.getLink();
		}
		
		return "";
	}	
	
	/* Get the Aspect Ratio, defined as height / width */
	getAspectRatio() {
		return this.original.getAspectRatio();
	}
	
}




/** A specific sized instance of an image */
class ImageVariant {

	constructor(data) {
		this.uid = data.uid;
		this.link = data.link;
		this.mime = data.mime;
		this.width = data.width;
		this.height = data.height;
	}
	
	// Basic Getter
	
	getUID() {
		return this.uid;
	}
	
	getLink() {
		return linkBaseURL + this.link;
	}
	
	getMime() {
		return this.mime;
	}
	
	getWidth() {
		return this.width;
	}
	
	getHeight() {
		return this.height;
	}
	
	// Utility Functions
	
	getAspectRatio() {
		if (this.width != 0) {
			return this.height / this.width;
		} else {
			return 1;
		}
	}
	
}

/**	An embeded Youtube Video */
class MediaYouTube {

	constructor(data) {
		this.uid = data.uid;
		this.data = data;
	}
	
	// Basic Getter
	
	isImage() {
		return false;
	}

	isMultiMedia() {
		return true;
	}

	getMultiMediaHTML(mode) {
		if (typeof mode === "undefined") {
			mode = "default";
		}
		let style = "";
		if (mode == "preview") {
			style = " style='pointer-events: none;' ";
		}

		return "<iframe " + style + " width='100%'  height='100%' src='https://www.youtube.com/embed/" + this.data.videoID + "?rel=0' title='YouTube video player' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>";
	}

	getUID() {
		return this.uid;
	}

	getAspectRatio() {
		return 9.0 / 16.0;
	}
	
}

/**	An embeded Video File */
class MediaVideo {

	constructor(data) {
		this.uid = data.uid;
		this.data = data;
	}
	
	// Basic Getter
	
	isImage() {
		return false;
	}

	isMultiMedia() {
		return true;
	}

	getMultiMediaHTML(mode) {
		if (typeof mode === "undefined") {
			mode = "default";
		}
		let style = "";
		if (mode == "preview") {
			style = " style='pointer-events: none;' ";
		}

		return "<video " + style + " width='100%' height='100%' controls><source src='" + linkBaseURL + this.data.original.link + "' type='" + this.data.original.mime + "'></video>";
	}
	
	getUID() {
		return this.uid;
	}

	getAspectRatio() {
		return 9.0 / 16.0;
	}
	
}

/**	An embeded Audio File */
class MediaAudio {

	constructor(data) {
		this.uid = data.uid;
	}
	
	// Basic Getter
	
	isImage() {
		return false;
	}

	isMultiMedia() {
		return true;
	}

	getMultiMediaHTML(mode) {
		if (typeof mode === "undefined") {
			mode = "default";
		}
		let style = "";
		if (mode == "preview") {
			style = " style='pointer-events: none;' ";
		}
		return "<audio " + style + " width='100%' height='100%' controls><source src='" + linkBaseURL + this.data.original.link + "' type='" + this.data.original.mime + "'></audio>";
	}

	getUID() {
		return this.uid;
	}

	getAspectRatio() {
		return 9.0 / 16.0;
	}
	
}